module.exports = __webpack_public_path__ + "static/terms-08b4d17afa7335f3bd9716d10e454891.svg";